import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

export const getProvince = createAsyncThunk(
  "customer/getProvince",
  async () => {
    const response = await http.get("/api/v1/province");
    return response.data;
  }
);

// Địa giới 2 cấp: xã trỏ thẳng về tỉnh (bỏ cấp huyện)
export const getWard = createAsyncThunk(
  "customer/getWard",
  async (province) => {
    const response = await http.get(`/api/v1/ward?province_id=${province}`);
    return response.data;
  }
);
